import * as React from "react";
import { useMemo } from "react";
import { useAppSelector } from "../hooks/storeHooks";

interface StoreSelectorProps {
  onOpenModal: () => void;
}

const StoreSelector: React.FC<StoreSelectorProps> = ({ onOpenModal }) => {
  const accounts = useAppSelector((state) => state.accounts.accounts);
  const activeAccountId = useAppSelector((state) => state.accounts.activeAccountId);

  const activeAccount = useMemo(
    () => accounts.find((account) => account.id === activeAccountId) || null,
    [accounts, activeAccountId]
  );

  return (
    <div className="flex items-center justify-between rounded-lg bg-white p-4 shadow-sm ring-1 ring-slate-200">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
            />
          </svg>
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-wider text-slate-500">Connected Store</p>
          <p className="text-sm font-semibold text-slate-900">
            {activeAccount ? activeAccount.label : "No store connected"}
          </p>
        </div>
      </div>
      <button
        onClick={onOpenModal}
        className="rounded-md border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400"
      >
        {activeAccount ? "Switch Store" : "Connect Store"}
      </button>
    </div>
  );
};

export default StoreSelector;
